import { render, staticRenderFns } from "./ResultsPDFList.vue?vue&type=template&id=1f13ab1a"
import script from "./ResultsPDFList.vue?vue&type=script&lang=js"
export * from "./ResultsPDFList.vue?vue&type=script&lang=js"
import style0 from "./ResultsPDFList.vue?vue&type=style&index=0&id=1f13ab1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports